
export default {
  name: 'AddressData',
  computed: {
    airport() {
      return this.$store.state.airport;
    },
    airportName() {
      return this.airport.name || null;
    },
    airportCountry() {
      return this.airport.country?.name || null;
    },
    airportCity() {
      return this.airport.address?.city || null;
    },
    airportAddress() {
      return this.airport.address?.street || null;
    },
    airportPostalCode() {
      return this.airport?.address?.zip_code || null;
    },
    merchantContent() {
      return this.$store.state.route.merchantContent;
    },
    airportInfo() {
      if (this.merchantContent?.airport_info) {
        return `(${this.$i18n(this.merchantContent.airport_info, { airport: this.airportName })})`;
      }
      return null;
    },
    merchantInfo() {
      if (this.merchantContent?.merchant_info) {
        return `(${this.$i18n(this.merchantContent.merchant_info, { merchant: this.merchantName })})`;
      }
      return null;
    },
    parkingService() {
      return this.$store.state.route.parkingService;
    },
    isValet() {
      return ['outdoor', 'indoor'].includes(this.parkingService.price_type);
    },
    airportAddressIsComplete() {
      return this.airportAddress && this.airportCity && this.airportPostalCode && this.airportCountry;
    },
    merchantName() {
      return this.merchantContent?.merchant || null;
    },
    merchantAddress() {
      if (this.isValet && this.airportAddressIsComplete) return this.airportAddress;

      return this.merchantContent?.merchant_address || null;
    },
    merchantCity() {
      if (this.isValet && this.airportAddressIsComplete) return this.airportCity;

      return this.merchantContent?.merchant_city_name || null;
    },
    merchantCountry() {
      if (this.isValet && this.airportAddressIsComplete) return this.airportCountry;

      return this.merchantContent?.merchant_country || null;
    },
    merchantPostalCode() {
      if (this.isValet && this.airportAddressIsComplete) return this.airportPostalCode;

      return this.merchantContent?.merchant_postal_code || null;
    },
    merchantPhone() {
      return this.merchantContent?.merchant_phone || null;
    },
  },
};
